import React from 'react';
import { object, string, ref } from 'yup';
import omit from 'lodash/omit';
import { useTranslation } from 'react-i18next';

import FormResource from './FormResource.jsx';
import FormGroup from '~/commons/components/FormGroup.jsx';
import FormCheckGroup from '~/commons/components/FormCheckGroup.jsx';

import { env } from '../../config';

const defaults = {
  active: true,
  email: '',
  password: '',
  name: { full: { en: '', zhhk: '' } },
};

const FormAdmin = ({
  school,
  schoolClass,
  admin,
}) => {
  const isSchoolAdmin = env.user.roles.includes('schoolAdmin');
  const isSupervisor = !env.user.schoolClass;
  const classList = schoolClass ? schoolClass.rows : null;
  const { t } = useTranslation();

  return (
    <FormResource
      {...{
        defaults: {
          ...defaults,
          ...(
            school
              ? { school: school._id, roles: ['schoolAdmin'], schoolClass: null }
              : { roles: ['admin'] }
          ),
          ...(isSchoolAdmin ? { confirmPassword: '' } : ''),
        },
        schema: object({
          email: string().email().required(),
          ...(!admin ? {
            password: string().required(),
          } : {}),
          ...(isSchoolAdmin ? {
            confirmPassword: string()
              .when(
                'password',
                {
                  is: (p) => p,
                  then: (s) => s.required().oneOf(
                    [ref('password')],
                    'Password does not match',
                  ),
                },
              ),
          } : {}),
        }),
        stored: admin,
        api: '/api/core/users/admins',
        onSubmit: (v) => {
          v = omit(v, !v.password ? 'password' : null);
          return {
            ...v,
            schoolClass: v.schoolClass ? v.schoolClass : null,
          };
        },
      }}
    >
      {env.user.roles.includes('admin') && (
        <div className="form-group">
          <label>{t('Active')}</label>
          <FormCheckGroup
            name="active"
            type="checkbox"
            label=""
            asSwitch
          />
        </div>
      )}
      {school && (
        <div className="form-group mb-0">
          <label>{`${t('Class')} (${t('Not selecting class means this is a supervisor account')})`}</label>
          <div className="form-row">
            <div className="col-2">
              <FormGroup name="schoolClass" label={null} as="select">
                <option value=""> - </option>
                {classList.map((c) => (
                  <option key={c._id} value={c._id}>
                    {c.title}
                  </option>
                ))}
              </FormGroup>
            </div>
          </div>
        </div>
      )}
      <FormGroup
        name="email"
        disabled={isSchoolAdmin && !isSupervisor}
        label={t('Email')}
      />
      <div className="form-row">
        <div className="col">
          <FormGroup name="name.full.zhhk" label={t('Name (Chinese)')} />
        </div>
        <div className="col">
          <FormGroup name="name.full.en" label={t('Name (English)')}/>
        </div>
      </div>
      <div className="form-row">
        <div className="col">
          <FormGroup
            name="password"
            type="password"
            label={t('Password')}
            placeholder={
              admin ? t('Leave this blank to keep the stored password') : ''
            }
          />
        </div>
        {isSchoolAdmin && (
          <div className="col">
            <FormGroup
              name="confirmPassword"
              label={t('Confirm Password')}
              type="password"
              placeholder={
                admin ? t('Leave this blank to keep the stored password') : ''
              }
            />
          </div>
        )}
      </div>
    </FormResource>
  );
};

export default FormAdmin;
